import React, { useState, useEffect } from "react";
import PasswordInput from "../components/PasswordInput";

const PIN = "7iron";
const ORGANISER_PIN = "Triton42";
const WEEK1_SLOTS = ["slot_1","slot_2","slot_3","slot_4","slot_5","slot_6","slot_7","slot_8"];
const WEEK2_SLOTS = ["slot_1b","slot_2b","slot_3b","slot_4b","slot_5b","slot_6b","slot_7b","slot_8b"];

export default function TuesdayGolf() {
  const [pinInput, setPinInput] = useState("");
  const [authed, setAuthed] = useState(false);
  const [pinError, setPinError] = useState("");
  const [data, setData] = useState({
    event_date: "", tee_time_1: "", tee_time_2: "",
    slot_1: "", slot_2: "", slot_3: "", slot_4: "", slot_5: "", slot_6: "", slot_7: "", slot_8: "",
    event_date_2: "", tee_time_1b: "", tee_time_2b: "",
    slot_1b: "", slot_2b: "", slot_3b: "", slot_4b: "", slot_5b: "", slot_6b: "", slot_7b: "", slot_8b: ""
  });
  const [editing, setEditing] = useState({});
  const [toast, setToast] = useState("");
  const [isOrganiser, setIsOrganiser] = useState(sessionStorage.getItem("tuesday_organiser") === "true");
  const [showOrganiserPrompt, setShowOrganiserPrompt] = useState(false);
  const [organiserPinInput, setOrganiserPinInput] = useState("");

  // Player Portal mode — recognises whoever's logged in from their token
  // instead of the shared PIN, so they don't have to remember it or type
  // their own name in. Guests/anyone not using the portal still use the
  // PIN exactly as before; the grid itself stays free-text either way so a
  // member can still sign a guest up under any spare slot.
  const playerToken = sessionStorage.getItem("player_token");
  const playerName = sessionStorage.getItem("player_name");
  const playerMode = !!playerToken;

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  useEffect(() => {
    if (playerMode) { setAuthed(true); loadData(); return; }
    const stored = sessionStorage.getItem("tuesday_pin");
    if (stored === PIN) { setAuthed(true); loadData(); }
  }, []);

  const loadData = () => {
    fetch("/api/auth/tuesday")
      .then(r => r.json())
      .then(d => setData(prev => ({ ...prev, ...d })))
      .catch(() => {});
  };

  const submitPin = () => {
    if (pinInput === PIN) {
      sessionStorage.setItem("tuesday_pin", PIN);
      setAuthed(true);
      loadData();
    } else {
      setPinError("Incorrect PIN — try again");
    }
  };

  const submitOrganiserPin = () => {
    if (organiserPinInput === ORGANISER_PIN) {
      sessionStorage.setItem("tuesday_organiser", "true");
      setIsOrganiser(true);
      setShowOrganiserPrompt(false);
      setOrganiserPinInput("");
      showToast("Organiser unlocked — you can now set the date and tee times");
    } else {
      showToast("Incorrect organiser PIN");
    }
  };

  const save = async (updates) => {
    setData(d => ({ ...d, ...updates }));
    try {
      // Send only the field(s) actually being changed, not the whole local
      // state — this page has no login for PIN users, so another visitor's
      // browser may have an older copy of fields we're not touching (e.g.
      // the date). Sending everything would silently revert their more
      // recent change.
      const headers = { "Content-Type": "application/json" };
      const body = { ...updates };
      if (playerMode) headers.Authorization = "Bearer " + playerToken;
      else body.pin = PIN;
      // Date/tee-time changes are organiser-only on the server — this is
      // only sent when unlocked, but the real enforcement is server-side,
      // since anyone could otherwise call the API directly with the shared
      // PIN and change the round for everyone.
      if (isOrganiser) body.organiser_pin = ORGANISER_PIN;
      const res = await fetch("/api/auth/tuesday", {
        method: "POST",
        headers,
        body: JSON.stringify(body)
      });
      const d = await res.json();
      if (d.error) { showToast("Error: " + d.error); return; }
      setData(d);
      showToast("Saved");
    } catch(e) { showToast("Network error"); }
  };

  const findEmptySlot = (slotKeys) => slotKeys.find(s => !data[s]);
  const findMySlot = (slotKeys) => slotKeys.find(s => (data[s] || "").trim().toLowerCase() === (playerName || "").trim().toLowerCase());

  const signMeUp = (slotKeys) => {
    const slot = findEmptySlot(slotKeys);
    if (!slot) { showToast("No spaces left"); return; }
    save({ [slot]: playerName });
  };

  const removeMe = (slotKeys) => {
    const slot = findMySlot(slotKeys);
    if (!slot) return;
    save({ [slot]: "" });
  };

  const renderSlots = (slotKeys) => slotKeys.map((slot, i) => {
    const name = data[slot] || "";
    const currentVal = editing[slot] !== undefined ? editing[slot] : name;
    const isMe = playerMode && name.trim().toLowerCase() === (playerName || "").trim().toLowerCase();
    return (
      <div key={slot} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", marginBottom: "6px", background: isMe ? "#dcfce7" : (name ? "#f0fdf4" : "#f9fafb"), borderRadius: "8px", border: isMe ? "1px solid #16a34a" : (name ? "1px solid #bbf7d0" : "1px solid #e5e7eb") }}>
        <span style={{ fontSize: "12px", fontWeight: "700", color: "#9ca3af", width: "16px" }}>{i + 1}</span>
        <input type="text"
          value={currentVal}
          placeholder="Enter name..."
          onChange={e => setEditing(prev => ({ ...prev, [slot]: e.target.value }))}
          onFocus={() => { if (editing[slot] === undefined) setEditing(prev => ({ ...prev, [slot]: name })); }}
          onKeyDown={e => {
            if (e.key === "Enter" && editing[slot]?.trim()) {
              save({ [slot]: editing[slot].trim() });
              setEditing(prev => { const n = {...prev}; delete n[slot]; return n; });
            }
            if (e.key === "Escape") {
              setEditing(prev => { const n = {...prev}; delete n[slot]; return n; });
            }
          }}
          style={{ flex: 1, border: "none", outline: "none", fontSize: "14px", fontWeight: name ? "600" : "400", color: name ? "#14532d" : "#9ca3af", background: "transparent" }} />
        {isMe && <span style={{ fontSize: "10px", fontWeight: "700", color: "#16a34a" }}>YOU</span>}
        <button
          onMouseDown={e => {
            e.preventDefault();
            if (name) {
              save({ [slot]: "" });
              setEditing(prev => { const n = {...prev}; delete n[slot]; return n; });
            } else {
              const val = (editing[slot] || "").trim();
              if (val) {
                save({ [slot]: val });
                setEditing(prev => { const n = {...prev}; delete n[slot]; return n; });
              }
            }
          }}
          style={{ width: "24px", height: "24px", borderRadius: "4px", border: "1px solid #d1d5db", background: name ? "#166534" : "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          {name && <span style={{ color: "white", fontSize: "14px", fontWeight: "800" }}>✓</span>}
        </button>
      </div>
    );
  });

  const renderWeek = (label, dateKey, t1Key, t2Key, slotKeys) => {
    const filledCount = slotKeys.filter(s => data[s]).length;
    const mySlot = playerMode ? findMySlot(slotKeys) : undefined;
    return (
      <div style={{ flex: 1, minWidth: "280px", background: "white", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", overflow: "hidden" }}>
        <div style={{ background: "#14532d", padding: "16px" }}>

          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "8px", padding: "8px 12px", flex: 1 }}>
              <div style={{ fontSize: "10px", color: "#86efac", fontWeight: "600", marginBottom: "4px" }}>DATE {!isOrganiser && "🔒"}</div>
              <input type="date" value={data[dateKey] || ""} disabled={!isOrganiser}
                onChange={e => setData(d => ({ ...d, [dateKey]: e.target.value }))}
                onBlur={() => save({ [dateKey]: data[dateKey] })}
                style={{ background: "transparent", border: "none", color: "white", fontSize: "13px", fontWeight: "700", width: "100%", cursor: isOrganiser ? "pointer" : "not-allowed", opacity: isOrganiser ? 1 : 0.7 }} />
            </div>
            <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "8px", padding: "8px 12px", minWidth: "90px" }}>
              <div style={{ fontSize: "10px", color: "#86efac", fontWeight: "600", marginBottom: "4px" }}>TEE 1 {!isOrganiser && "🔒"}</div>
              <input type="time" value={data[t1Key] || ""} disabled={!isOrganiser}
                onChange={e => setData(d => ({ ...d, [t1Key]: e.target.value }))}
                onBlur={() => save({ [t1Key]: data[t1Key] })}
                style={{ background: "transparent", border: "none", color: "white", fontSize: "13px", fontWeight: "700", width: "100%", cursor: isOrganiser ? "pointer" : "not-allowed", opacity: isOrganiser ? 1 : 0.7 }} />
            </div>
            <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "8px", padding: "8px 12px", minWidth: "90px" }}>
              <div style={{ fontSize: "10px", color: "#86efac", fontWeight: "600", marginBottom: "4px" }}>TEE 2 {!isOrganiser && "🔒"}</div>
              <input type="time" value={data[t2Key] || ""} disabled={!isOrganiser}
                onChange={e => setData(d => ({ ...d, [t2Key]: e.target.value }))}
                onBlur={() => save({ [t2Key]: data[t2Key] })}
                style={{ background: "transparent", border: "none", color: "white", fontSize: "13px", fontWeight: "700", width: "100%", cursor: isOrganiser ? "pointer" : "not-allowed", opacity: isOrganiser ? 1 : 0.7 }} />
            </div>
          </div>
        </div>
        <div style={{ padding: "12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <span style={{ fontSize: "13px", fontWeight: "700", color: "#14532d" }}>Players</span>
            <span style={{ background: filledCount === 8 ? "#dc2626" : "#166534", color: "white", fontSize: "11px", fontWeight: "700", padding: "2px 10px", borderRadius: "20px" }}>
              {filledCount} / 8
            </span>
          </div>
          {playerMode && (
            <button onClick={() => mySlot ? removeMe(slotKeys) : signMeUp(slotKeys)}
              style={{
                width: "100%", marginBottom: "10px", border: "none", borderRadius: "8px", padding: "9px",
                fontSize: "13px", fontWeight: "700", cursor: "pointer",
                background: mySlot ? "#fee2e2" : "#166534", color: mySlot ? "#b91c1c" : "white"
              }}>
              {mySlot ? "✕ Remove Me" : "✓ Sign Me Up"}
            </button>
          )}
          {renderSlots(slotKeys)}
        </div>
      </div>
    );
  };

  if (!authed) {
    return (
      <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
        <div style={{ background: "white", borderRadius: "16px", padding: "36px 32px", width: "100%", maxWidth: "360px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", textAlign: "center" }}>
          <div style={{ fontSize: "48px", marginBottom: "8px" }}>⛳</div>
          <h1 style={{ fontSize: "22px", fontWeight: "800", color: "#14532d", margin: "0 0 4px" }}>Pin High</h1>
          <p style={{ fontSize: "14px", color: "#6b7280", margin: "0 0 24px" }}>Tuesday Golf Sign-Up</p>
          {pinError && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "8px 12px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{pinError}</div>}
          <PasswordInput value={pinInput} onChange={e => setPinInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && submitPin()} placeholder="Enter PIN"
            style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "18px", textAlign: "center", letterSpacing: "6px", boxSizing: "border-box" }}
            wrapperStyle={{ marginBottom: "16px" }} />
          <button onClick={submitPin}
            style={{ width: "100%", background: "#14532d", color: "white", border: "none", borderRadius: "8px", padding: "12px", fontSize: "15px", fontWeight: "700", cursor: "pointer" }}>
            Enter
          </button>
          <a href="/player/login" style={{ display: "block", marginTop: "16px", fontSize: "12px", color: "#6b7280" }}>Have a Player Portal login? Sign in there instead</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4" }}>
      {toast && (
        <div style={{ position: "fixed", bottom: "20px", left: "50%", transform: "translateX(-50%)", background: "#166534", color: "white", padding: "10px 24px", borderRadius: "10px", fontSize: "14px", fontWeight: "600", zIndex: 9999, boxShadow: "0 4px 16px rgba(0,0,0,0.2)" }}>
          {toast}
        </div>
      )}
      <div style={{ background: "#14532d", padding: "16px 20px", textAlign: "center", position: "relative" }}>
        <h1 style={{ color: "white", fontSize: "22px", fontWeight: "900", margin: 0 }}>⛳ Pin High Tuesday Golf</h1>
        {playerMode ? (
          <p style={{ color: "#86efac", fontSize: "12px", margin: "4px 0 0" }}>👤 Signed in as {playerName} · Tap Sign Me Up, or edit any slot directly</p>
        ) : (
          <p style={{ color: "#86efac", fontSize: "12px", margin: "4px 0 0" }}>Type your name and press Enter or tick to sign up · Untick to remove</p>
        )}
        {isOrganiser ? (
          <div style={{ marginTop: "8px", fontSize: "11px", fontWeight: "700", color: "#bbf7d0" }}>🔓 Organiser mode — date and tee times unlocked</div>
        ) : (
          <button onClick={() => setShowOrganiserPrompt(true)}
            style={{ marginTop: "8px", background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "6px", color: "#bbf7d0", fontSize: "11px", fontWeight: "700", padding: "4px 10px", cursor: "pointer" }}>
            🔒 Organiser — set date/times
          </button>
        )}
        {showOrganiserPrompt && (
          <div style={{ marginTop: "10px", display: "flex", gap: "6px", justifyContent: "center" }}>
            <PasswordInput value={organiserPinInput} onChange={e => setOrganiserPinInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && submitOrganiserPin()} placeholder="Organiser PIN"
              style={{ border: "1.5px solid #bbf7d0", borderRadius: "6px", padding: "6px 10px", fontSize: "13px", width: "140px" }} />
            <button onClick={submitOrganiserPin}
              style={{ background: "#bbf7d0", color: "#14532d", border: "none", borderRadius: "6px", padding: "6px 12px", fontSize: "12px", fontWeight: "700", cursor: "pointer" }}>
              Unlock
            </button>
          </div>
        )}
      </div>
      <div style={{ padding: "16px", display: "flex", gap: "16px", flexWrap: "wrap", maxWidth: "900px", margin: "0 auto" }}>
        {renderWeek("Week 1", "event_date", "tee_time_1", "tee_time_2", WEEK1_SLOTS)}
        {renderWeek("Week 2", "event_date_2", "tee_time_1b", "tee_time_2b", WEEK2_SLOTS)}
      </div>
      <div style={{ textAlign: "center", padding: "16px 20px 24px", maxWidth: "900px", margin: "0 auto" }}>
        <div style={{ background: "#fef9c3", border: "1px solid #fde047", borderRadius: "10px", padding: "12px 20px", fontSize: "14px", fontWeight: "600", color: "#854d0e" }}>
          ⏰ Cut Off Time 3pm on Monday — After That Unused Tee Times Will Be Cancelled
        </div>
      </div>
    </div>
  );
}
